<template>
  <b-container fluid class="data-history">
    <b-row align-h="between">
      <b-col
        md="auto"
        cols="12"
      >
        <s-search-input
          v-model="searchTerm"
          v-s-trigger="getReports"
          :placeholder="$t('reports.search-report')"
        />
      </b-col>

      <b-col
        md="auto"
        cols="12"
      >
      <b-dropdown
        variant="primary"
        right
        class="mt-3 mt-md-0"
        :text="$t('reports.new-report')"
      >
        <b-dropdown-item @click="newReport">
          {{ $t('reports.new-report') }}
        </b-dropdown-item>
        <b-dropdown-item @click="openModalImportTemplate">
          {{ $t('reports.new-report-import') }}
        </b-dropdown-item>
      </b-dropdown>
      </b-col>
    </b-row>

    <b-row
      align-h="center"
      class="mt-3"
    >
      <b-col class="p-0">
        <data-history-list
          :pagination="pagination"
          :reports="reports"
          :loading="loading"
          :sort-by.sync="sortBy"
          @refresh-list="getReports"
          @page-changed="onPageChanged"
          @sort-changed="sort"
        />
      </b-col>
    </b-row>
    <import-template-modal
      v-model="showImportReportModal"
      :input-accept="allowedFiles"
      :isMultipleUpload="false"
      @fileUploaded="importTemplateJson"
    />
  </b-container>
</template>

<script>
import LoadingMixin from '@/services/loadingMixin';
import DataHistoryService, { UPLOAD_ALLOWED_FILE_TYPES } from '@/domain/services/generalPanel/reports/dataHistory';
import DataHistoryList from '@/domain/components/generalPanel/reports/dataHistory/List';
import ImportTemplateModal from '@/domain/components/generalPanel/reports/dataHistory/importTemplateModal';

export default {
  name: 'ViewReport',
  components: {
    DataHistoryList,
    ImportTemplateModal,
  },
  mixins: [
    LoadingMixin,
  ],
  data: () => ({
    searchTerm: null,
    lastSearchTerm: null,
    showImportReportModal: false,
    reports: [],
    assets: [],
    pagination: {
      perPage: 10,
      currentPage: 1,
      totalRows: null,
    },
    sortBy: {
      field: 'reportName',
      desc: false,
    },
    allowedFiles: UPLOAD_ALLOWED_FILE_TYPES,
  }),
  created() {
    this.getReports();
  },
  methods: {
    newReport() {
      this.$router.push({ name: 'reports.data-history.new-report' });
    },
    onPageChanged(page) {
      this.pagination.currentPage = page;
      this.getReports();
    },
    callGetListService(params) {
      this.startLoading();
      DataHistoryService.getList(params).then((response) => {
        this.reports = response.data;
        this.pagination.perPage = response.pageSize;
        this.pagination.currentPage = response.page;
        this.pagination.totalRows = response.total;
      }).finally(() => { this.endLoading(); });
    },
    getReports() {
      const sort = {};
      sort[this.sortBy.field] = this.sortBy.desc ? 'desc' : 'asc';
      const params = {
        page: this.pagination.currentPage,
        pageSize: this.pagination.perPage,
        sort,
        filter: {
          reportName: this.searchTerm || null,
        },
      };
      this.callGetListService(params);
    },
    sort(evt) {
      this.sortBy.field = evt.sortBy;
      this.sortBy.desc = evt.sortDesc;
      this.currentPage = 1;
      this.getReports();
    },
    openModalImportTemplate() {
      this.showImportReportModal = true;
    },
    closeModalImportTemplate() {
      this.showImportReportModal = false;
      this.getReports();
    },
    importTemplateJson(file) {
      if (file.length === 0) {
        return false;
      }

      const extension = `.${file[0].name.split('.')[1]}`;
      if (!this.isValidExtensionTemplateImport(extension)) return false;

      const uploadedFile = file[0];
      const reader = new FileReader();

      if (uploadedFile) {
        reader.readAsText(uploadedFile);
      }

      reader.addEventListener('load', () => (
        DataHistoryService.importTemplate(JSON.parse(reader.result))
        .then(() => {
          this.$pushAlert({ code: 'MS006' });
        })
        .finally(() => {
          this.closeModalImportTemplate();
        })
      ));

      return true;
    },
    isValidExtensionTemplateImport(extension) {
      if (this.allowedFiles.indexOf(extension)) {
        this.$pushAlert({ code: 'ME033' });
        return false;
      }

      return true;
    },
  },
};
</script>
